import React from 'react';
import { Form } from '@ant-design/compatible';
import { Button, Checkbox, Select, Tooltip, Input } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import moment from 'moment';
import { graphql, compose, withApollo } from 'react-apollo';


// import { useParams } from 'react-router-dom';



/**
 * Public component for displaying QR code verification information
 * This component is accessible without authentication
 */

const FormItem = Form.Item;
const Option = Select.Option;

class FormVerificacionAutorizacionMenor extends React.Component {

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log("values ------ ", values);
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  render() {

    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Verificacion Autorizacion de Viaje de Menor</h1>
        <div style={{ marginBottom: '30px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '5px', border: '1px solid #e8e8e8' }}>
          <h3 style={{ color: '#096dd9' }}>¿Qué es este servicio?</h3>
          <p>Este sistema permite verificar la autenticidad de una autorización de viaje para menores otorgada por el Poder Judicial de Neuquén.</p>
          
          <h3 style={{ color: '#096dd9', marginTop: '15px' }}>¿Cómo verificar una autorización?</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Ingrese el código QR que aparece en el documento de autorización</li>
            <li>El código debe ingresarse respetando mayúsculas y minúsculas exactamente como aparece</li>
            <li>Presione Buscar para verificar la validez del documento</li>
          </ul>
          <div style={{ backgroundColor: '#e6f7ff', padding: '10px', borderRadius: '4px', marginTop: '15px', borderLeft: '4px solid #1890ff' }}>
            <Icons.InfoCircleOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
            <span>Este servicio es público y no requiere autenticación.</span>
          </div>
        </div>

        <Form onSubmit={this.handleSubmit} className="formAuthMenor">
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Código QR
                <Tooltip title="Ingrese el código exactamente como aparece en el documento">
                  <Icons.QuestionCircleOutlined style={{ marginLeft: '5px' }} />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('codigoAuth', {
              rules: [
                {
                  required: true,
                  message: 'Por favor ingrese el código.',
                },
              ],
            })(<Input style={{ width: '50%' }} placeholder="Ej: ABC123456" />)}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit" icon={<Icons.SearchOutlined />}>
              Verificar Autorización
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    moment.locale();
    return {
      codigoAuth: Form.createFormField({
        value: props.codigoAuth ? props.datos.codigoAuth : '',
      }),
    };
  },
})(FormVerificacionAutorizacionMenor);
